/**
 * Participant colours for live presence in a shared project (vfs-service src/collab/presence.js assigns each person a
 * slot: the owner first, then the members as listed; Flow's chat agent slot 4, other AI tools slot 5). Five slots from
 * the suite's colour-blind-safe categorical palette, at the darker step so white initials and coloured text pass
 * 4.5:1; in dark mode the inks step up one notch and initials turn dark. Blue/purple and blue/teal are close for some
 * readers, which is why people are round and agents square and dashed, and why every mark carries initials or a name.
 */
export const PARTICIPANT_SLOTS = Object.freeze([
  { ink: '#0958D9', tint: '#E6F0FF', darkInk: '#3C89E8' },
  { ink: '#AD4E00', tint: '#FFF1E0', darkInk: '#D87A16' },
  { ink: '#006D75', tint: '#DFF5F5', darkInk: '#13A8A8' },
  { ink: '#531DAB', tint: '#F3EBFF', darkInk: '#9254DE' },
  { ink: '#9E1068', tint: '#FDEAF4', darkInk: '#CB2B83' },
]);

// utils/themeMode.js puts `dark-mode` on <html> for the dark themes.
const isDark = () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark-mode');

const slotOf = (slot) => PARTICIPANT_SLOTS[((Number(slot) || 0) % PARTICIPANT_SLOTS.length + PARTICIPANT_SLOTS.length) % PARTICIPANT_SLOTS.length];

/** The slot's ink (avatar, flag, caret), for the current theme. */
export const inkFor = (slot, dark = isDark()) => (dark ? slotOf(slot).darkInk : slotOf(slot).ink);

/** The slot's tint (selection, row background); a translucent ink in dark mode. */
export const tintFor = (slot, dark = isDark()) => (dark ? `${slotOf(slot).darkInk}33` : slotOf(slot).tint);

/** The text colour on the ink: white, or near-black on dark mode's lighter inks. */
export const onInkFor = (dark = isDark()) => (dark ? '#141414' : '#FFFFFF');
